import { render, staticRenderFns } from "./AgendaLista.vue?vue&type=template&id=9f66e750&scoped=true&"
import script from "./AgendaLista.vue?vue&type=script&lang=js&"
export * from "./AgendaLista.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f66e750",
  null
  
)

export default component.exports